import "./ComoFunciona.css";

const ComoFunciona = () => {
  return (
    <div className="como_container">
      <h2>Como funciona</h2>
      <h3>1. Como fazer pedido?</h3>
      <p>
        Escolha um template, clique em <b>Fazer Pedido</b>, o nome e o codigo do
        template será copiado, basta entrar em alguma das nossas redes sociais e
        entrar em contato.
      </p>
      <h3>2. Eu devo fazer as modificações?</h3>
      <p>
        Não, você compra o template e eu faço as modificações para você, então
        não se preocupe!
      </p>
      <h3>3. Quantas vezes posso pedir para fazer alterações?</h3>
      <p className="alert_p">
        Nós temos um limite, após você fazer a compra, você deve pensar o que
        deve ser modificado e apagado do template, como textos, imagens, cores,{" "}
        <b>!!! não modificamos o layout !!!</b> então você tem <b>1 MODIFICAÇÃO
        GERAL</b> após a compra, após dar os detalhes da primeira alteração geral,
        você terá somente mais uma opção de alteração, após isso as alterações
        seram cobradas.
      </p>
      <h3>4. Se eu querer um layout e template personalizado, criado do zero?</h3>
      <p>Temos a opção de layout personalizado também, o orçamento vai de cada trabalho e tempo gasto.</p>
      <h3>5. Caso haja mais duvidas entre em contato nas nossas redes sociais.</h3>
    </div>
  );
};

export default ComoFunciona;
